import { AxiosInstance } from 'axios';
import {
  HeadlinesDepartmentsListResultDto,
  HeadlinesDepartmentsListResultModel,
  mapHeadlinesDepartmentsListResultDtoToModel,
} from 'api/dto/new/Headlines/HeadlinesDepartment.dto';

export class HeadlinesApi {
  constructor(private client: AxiosInstance) {}

  getDepartments(surveyId: string): Promise<HeadlinesDepartmentsListResultModel> {
    return this.client
      .get<HeadlinesDepartmentsListResultDto>(`/api/survey/${surveyId}/headlines/departments`)
      .then((response) => mapHeadlinesDepartmentsListResultDtoToModel(response.data));
  }
}
